import styles from "./StickyBar.module.scss";
import { Button } from "../../../Button/Button";
import { Picture } from "@/components/shared/Picture/Picture";
import { ImageQueryResult } from "@/sanity/queries";

interface StickyBarProps {
	onSearchClick: () => void;
	image?: ImageQueryResult | null;
	heading?: string | null;
	text?: string | null;
	buttonLabel?: string | null;
}

export const StickyBar = ({
	onSearchClick,
	image,
	heading = "Enter NMI manually",
	text = "Find your connection using your connection National Meter Identifier (NMI).",
	buttonLabel = "Search NMI",
}: StickyBarProps) => {
	return (
		<>
			<div
				className={styles["sticky-bg"]}
				aria-hidden="true"
			/>

			<div className={styles["sticky-bar"]}>
				<div className={styles["sticky-bar__inner"]}>
					{image?.image && (
						<div className={styles["sticky-bar__image"]}>
							<Picture
								className={styles["sticky-bar__picture"]}
								sanityImage={image.image}
								alt={image.altText}
								width={120}
								height={72}
								crop
							/>
						</div>
					)}

					<div className={styles["sticky-bar__body"]}>
						<div className={styles["sticky-bar__copy"]}>
							<p className={styles["sticky-bar__heading"]}>{heading}</p>
							<p>{text}</p>
						</div>

						<Button
							type="button"
							theme="compact"
							label={buttonLabel}
							className={styles["sticky-bar__button"]}
							onClick={onSearchClick}
						/>
					</div>
				</div>
			</div>
		</>
	);
};
